import React from 'react';
import { Tag } from 'antd';
import { injectIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { generatePath, useHistory, useParams } from 'react-router-dom';
import { ROUTE_PACIENTES_EYECHART_WATCH } from '../../../../routes.constants';

function Optometria({ intl, data }:any) {
  const history = useHistory();
  const { pacienteId }: any = useParams();

  return (
    <>
      <div key={data.codigo} className="bodyCard flexRow spaceBetween">
        <div>
          <h3>{intl.formatMessage({ id: 'pacientes.client_file.optometry' })}</h3>
          <span className="dateNPlace">
            {data.fecha}
            {' '}
            /
            {' '}
            {data.nombre_tienda}
          </span>
          <p className="blueLink" onClick={() => history.push(generatePath(ROUTE_PACIENTES_EYECHART_WATCH, { pacienteId, codigo: data.codigo, tiendaGraduacion: data.tienda_id }))}>
            {intl.formatMessage({ id: 'pacientes.activity.graduation' })}
            Nº
            {' '}
            {data.codigo}
          </p>
          <div className="grads flexCol">
            <div className="flexRow">
              <Tag>{intl.formatMessage({ id: 'pacientes.activity.RE' })}</Tag>
              <p>{data.resumen.resumen_ojo_derecho}</p>
            </div>
            <div className="flexRow lastGrad">
              <Tag>{intl.formatMessage({ id: 'pacientes.activity.LE' })}</Tag>
              <p>{data.resumen.resumen_ojo_izquierdo}</p>
            </div>
          </div>
        </div>
        {false
          && (
          <div className="flexCol flexEnd">
            <div className="flexRow">
              <div className="marginBot16">
                <p className="blueLink">{intl.formatMessage({ id: 'pacientes.activity.documents' })}</p>
              </div>
            </div>
          </div>
          )
          }
      </div>
    </>

  );
}

export default injectIntl(Optometria);
